<template>
    <div class="accordion-item">
        <h2 class="accordion-header" id="register-accordion-header">
            <button class="accordion-button collapsed"
                :class="{ collapsed: !isActive }"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#register-accordion-body"
                :aria-expanded="isActive"
                aria-controls="register-accordion-body"
                :disabled="!wizardStore.isStepEnabled(3)"
                @click="wizardStore.toggleStep(3)">
                3. {{ $t("Registrering") }}
                <span class="fa fa-check float-right text-success ms-2"
                    :class="{ 'd-none': !wizardStore.isStepCompleted(3) }"
                    style="line-height: 24px"></span>
            </button>
        </h2>
        <div id="register-accordion-body"
            class="accordion-collapse collapse"
            :class="{ show: isActive || (vippsUser.exists && !wizardStore.isStepCompleted(3)) }"
            data-bs-parent="#booking-accordions">
            <div class="accordion-body">
                <p class="alert alert-info">
                    <span v-if="userType === '0'">{{ $t('Ved å fortsette blir du opprettet som elev på skolen.') }}</span>
                    <span v-else>{{ $t('Du blir opprettet som kontaktperson til eleven du registrerer.') }}</span>
                </p>

                <!-- Student Fields -->
                <StudentForm
                    :student="student"
                    :user-type="userType"
                    :classes="classes"/>

                <!-- Contacts Section -->
                <hr>
                <h5>{{ $t("Kontaktpersoner") }}</h5>

                <ContactForm
                    v-for="(contact, index) in contacts"
                    :key="contact.id"
                    :contact="contact"
                    :index="index"
                    @remove="wizardStore.removeContact(contact.id)"/>

                <button
                    type="button"
                    class="btn btn-outline-primary mb-3"
                    @click="wizardStore.addContact()">
                    <i class="fa fa-plus me-2"></i>
                    {{ $t("Legg til kontaktperson") }}
                </button>

                <div class="row mt-2">
                    <div class="col-sm-12 text-end">
                        <button
                            class="btn btn-primary rounded-0"
                            @click.prevent="wizardStore.register()"
                            :disabled="loading">
                            {{ loading ? $t("Laster...") : $t("Fortsett") }}
                        </button>
                    </div>
                </div>

                <!-- Feedback -->
                <div v-if="feedback" class="feedback mt-2" v-html="feedback"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {computed} from 'vue'
    import wizardStore from '../../state/vippsWizardStore.js'
    import ContactForm from './ContactForm.vue'
    import StudentForm from './StudentForm.vue'

    const props = defineProps({
        isActive: Boolean
    })

    // Computed properties
    const userType = computed(() => wizardStore.state.userType.value)
    const vippsUser = computed(() => wizardStore.state.vippsUser.value)
    const student = computed(() => wizardStore.state.student.value)
    const contacts = computed(() => wizardStore.state.contacts.value)
    const classes = computed(() => wizardStore.state.classes.value)
    const loading = computed(() => wizardStore.state.loading.value)
    const feedback = computed(() => wizardStore.state.feedback.value)
</script>
